import script from "./AddSalary.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSalary.vue?vue&type=script&setup=true&lang=js"

import "./AddSalary.vue?vue&type=style&index=0&id=5735e86a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5735e86a"]])

export default __exports__